<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import { fraseDaRecusa } from 'dashboard/helper/recusaDoAcesso';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { mfa_required: mfaRequired } = currentAccount.value?.settings || {};
    isEnabled.value = !!mfaRequired;
  },
  { deep: true, immediate: true }
);

const toggleMfaRequired = async () => {
  try {
    await updateAccount({ mfa_required: isEnabled.value });
    useAlert(t('GENERAL_SETTINGS.FORM.MFA_REQUIRED.API.SUCCESS'));
  } catch (error) {
    // ACESSO-01 (L11b): a recusa do acesso diz a frase do servidor.
    useAlert(
      fraseDaRecusa(error) || t('GENERAL_SETTINGS.FORM.MFA_REQUIRED.API.ERROR')
    );
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.MFA_REQUIRED.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.MFA_REQUIRED.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleMfaRequired" />
      </div>
    </template>
  </SectionLayout>
</template>
